// Constantes compartidas del calendario de citas.

export const PX_PER_HOUR = 64; // px por hora → 1 min = 64/60 ≈ 1.07 px

export const VIEW_TYPES = { day: 'Día', week: 'Semana', month: 'Mes' };

export const DURATION_OPTIONS = [
  { value: 20,  label: '20 min' },
  { value: 30,  label: '30 min' },
  { value: 40,  label: '40 min' },
  { value: 45,  label: '45 min' },
  { value: 60,  label: '1 hora' },
  { value: 90,  label: '1h 30 min' },
  { value: 120, label: '2 horas' },
];

export const MOTIVOS_PRESET = [
  'Limpieza dental / profilaxis',
  'Revisión y diagnóstico general',
  'Extracción dental',
  'Endodoncia / tratamiento de conducto',
  'Ortodoncia / ajuste',
];

export const MODALIDAD_OPTIONS = [
  { value: 'presencial', label: 'Presencial', costo: 650 },
  { value: 'en_linea',   label: 'Consulta en línea', costo: 300 },
];
